// extracted by mini-css-extract-plugin
export default {"root":"N4dhX","icon":"ZhH0S","text":"HB8PM"};